import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert/alert.component';
import { SelectAccountComponent } from './select-account/select-account.component';

@NgModule({
    imports: [
        MatDialogModule,
        CommonModule
    ],
    declarations: [
        AlertComponent,
        SelectAccountComponent
    ],
    exports: [
        AlertComponent,
        SelectAccountComponent
    ]
})

export class DialogsModule { }
